import { SvgIcon, theme } from '@salecycle/ui-component-library';
import { TooltipWithTitle } from '@salecycle/experimental/TooltipWithTitle';
import { TFunction } from 'i18next';
import styled from 'styled-components';
import { formatSegmentationForTooltip } from '../utils/formatSegmentationForTooltip';

type SegmentationRuleLike = { type: string; configuration?: { condition?: string; value?: string }; or?: boolean };

const TOOLTIP_TITLE_KEY = 'onsite.editor.workflow.triggerMessage.workflow.audienceSegmentsTooltipTitle';
const VIEW_DETAILS_ARIA_LABEL_KEY = 'onsite.editor.workflow.triggerMessage.workflow.viewAudienceSegmentsAriaLabel';
const AUDIENCE_AMOUNT_SEGMENT_KEY = 'onsite.editor.workflow.audienceAmountSegment';
const AUDIENCE_SINGLE_SEGMENT_KEY = 'onsite.editor.workflow.audienceSingleSegment';

function getSegmentsText(t: TFunction, amount: number): string {
  return amount > 1 || amount === 0
    ? t(AUDIENCE_AMOUNT_SEGMENT_KEY).replace(/\$\{a\}/g, String(amount))
    : t(AUDIENCE_SINGLE_SEGMENT_KEY);
}

const TriggerWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  margin-left: ${({ theme }) => theme.designToken.spacing1};
`;

const TooltipTriggerButton = styled.button`
  display: inline-flex;
  align-items: center;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
`;

export interface AudienceSegmentsTooltipProps {
  segmentation: SegmentationRuleLike[][];
  t: TFunction;
}

export function AudienceSegmentsTooltip({ segmentation, t }: AudienceSegmentsTooltipProps) {
  const segmentCount = segmentation?.length ? segmentation.flatMap(s => s.flatMap(p => p)).length : 0;

  return (
    <>
      {getSegmentsText(t, segmentCount)}
      <TriggerWrapper className="nodrag">
        <TooltipWithTitle
          title={t(TOOLTIP_TITLE_KEY)}
          content={formatSegmentationForTooltip(segmentation, t)}
          contentStyle={{ whiteSpace: 'pre-line' }}
          iconAriaLabel={t(VIEW_DETAILS_ARIA_LABEL_KEY)}
          position="bottom"
          trigger="mouseenter focusin click"
          distance={8}
          wrapperStyle={{ display: 'inline-flex' }}
        >
          <TooltipTriggerButton
            type="button"
            className="nodrag"
            onMouseDown={e => e.stopPropagation()}
            aria-label={t(VIEW_DETAILS_ARIA_LABEL_KEY)}
          >
            <SvgIcon name="circle-question" size="16" color={theme.designToken.primary700} />
          </TooltipTriggerButton>
        </TooltipWithTitle>
      </TriggerWrapper>
    </>
  );
}
